var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AvatarImage',_vm._b({staticClass:"bg-white",attrs:{"image":_vm.primaryAdvisorAvatar,"size":_vm.size}},'AvatarImage',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }